import { animate, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-side-bar-search-expandable-block',
  templateUrl: './app-side-bar-search-expandable-block.component.html',
  styleUrls: ['./app-side-bar-search-expandable-block.component.scss'],
  host: {
    'test-id': 'app-side-bar-search-expandable-block',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('toggle', [
      transition(':enter', [
        style({ height: 0 }),
        animate('0.15s ease-in', style({ height: '*' })),
      ]),
      transition(':leave', [
        style({ height: '*' }),
        animate('0.15s ease-in', style({ height: 0 })),
      ]),
    ]),
  ],
})
export class AppSideBarSearchExpandableBlockComponent {
  @Input() title: string;

  protected isExpanded = true;
}
